<template>
  <div class="more-arrow" @click="toJump"></div>
</template>
<script>
export default {
  name: "more-arrow",
  props: {
    path: String
  },
  setup(props) {
    const toJump = () => {
      if (props.path) {
        window.open(props.path, "_blank");
      }
    };
    return {
      toJump
    };
  }
};
</script>
<style scoped lang="less">
.more-arrow {
  width: 20px;
  height: 20px;
  background: url(../../assets/svg/more_arrow.svg) no-repeat center;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.more-arrow:hover {
  background: url(../../assets/svg/more_arrows.svg) no-repeat center;
}
</style>
